<template>
    <div :class="[ showIcon ? '' : 'fw-75', disabled ? 'disabled' : '', 'btn btn-info sq' ]" :id="id + 'button'" @click="promptFile">
      Upload <i v-if="showIcon" class="fa fa-upload"></i>
      <input v-if="showFile" type="file" :id="id + 'input'" class="hidden" @change="fileUploaded">
    </div>
</template>
<script>
  import Papa from 'papaparse'
  import XLSX from 'xlsx/xlsx'
  import FileSaver from 'file-saver'
  import event from '../../event.js'
  export default {
    name: 'ParseToJson',
    data () {
      return {
        showFile: true
      }
    },
    props: {
      filterEmptyColumns: {
        type: Boolean,
        default: true,
        required: false
      },
      // Not currently implemented @todo
      stream: {
        type: Boolean,
        default: false,
        required: false
      },
      showIcon: {
        type: Boolean,
        default: true,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      id () {
        return `ptj-${this._uid}-`
      }
    },
    methods: {
      isCSV (file) {
        return file.name.substr(file.name.length - 4) === '.csv'
      },
      isXLSX (file) {
        return file.name.substr(file.name.length - 5) === '.xlsx'
      },
      regenUploader () {
        this.showFile = false
        this.$nextTick(() => {
          this.showFile = true
        })
      },
      parseCSV (file) {
        let self = this
        self.$emit('parse-start')
        Papa.parse(file, {
          header: true,
          dynamicTyping: true,
          skipEmptyLines: self.filterEmptyColumns,
          /* ALLOWS STREAMING
          step: function (results, parser) {
            console.log(results)
          },
          */
          complete: function (results) {
            self.regenUploader()
            self.$emit('parse-complete', { data: results.data, fileName: file.name })
            // DOWNLOAD CODE BELOW
            // let blob = new Blob([Papa.unparse(results.data)], { type: 'text/csv;charset=utf-8' })
            // FileSaver.saveAs(blob, 'file.csv')
          }
        })
      },
      parseXLSX (file) {
        let self = this
        self.$emit('parse-start')
        let reader = new FileReader()
        reader.onload = function (e) {
          let binary = ''
          let bytes = new Uint8Array(e.target.result)
          let length = bytes.byteLength
          for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          let wb = XLSX.read(binary, {type: 'binary'})
          let wsname = wb.SheetNames[0]
          let ws = wb.Sheets[wsname]
          self.$emit('parse-complete', {
            data: XLSX.utils.sheet_to_json(ws, { defval: null }),
            fileName: file.name
          })
          self.regenUploader()
          // let wb = XLSX.utils.json_to_sheet(data)
          // var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

          /* force a download */
          // FileSaver.saveAs(new Blob([self.s2ab(wbout)], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
          // console.log(x)
        }
        reader.readAsArrayBuffer(file)
      },
      promptFile (e) {
        e.stopPropagation()
        if (!this.disabled) {
          this.$el.querySelector(`#${this.id}input`).click()
        }
      },
      fileUploaded (e) {
        let file = e.target.files[0] || e.dataTransfer.files[0]
        if (this.isCSV(file)) {
          this.parseCSV(file)
        } else if (this.isXLSX(file)) {
          this.parseXLSX(file)
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure file upload is either CSV or XLSX format' })
        }
      },
      filterEmpty (obj) {
        let isEmpty = true
        for (let prop in obj) {
          if (obj[prop]) {
            isEmpty = false
            break
          }
        }
        return isEmpty
      },
      s2ab (s) {
        if (typeof ArrayBuffer !== 'undefined') {
          let buf = new ArrayBuffer(s.length)
          let view = new Uint8Array(buf)
          for (let i = 0; i != s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        } else {
          let buf = new Array(s.length)
          for (let i = 0; i != s.length; ++i) {
            buf[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        }
      }
    }
  }
</script>
<style>
.hidden {
  display: none;
}
.fw-75 {
  width: 75px;
}
</style>



// WEBPACK FOOTER //
// src/modules/helpers/ParseToJson.vue